import { render } from "./AddEditOrderOneStryker.vue?vue&type=template&id=0ba0be43"
import script from "./AddEditOrderOneStryker.vue?vue&type=script&lang=js"
export * from "./AddEditOrderOneStryker.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__